import React from 'react';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Select from 'components/form/Formik/FormikReactSelect';
import RadioGroup from 'components/form/Formik/FormikRadioGroup';
import Switch from 'components/form/Formik/FormikSwitch';
import { FieldArray, Field } from 'formik';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ProductTypes from 'constant/product-types';
import times from 'lodash/times';
import { useQuery } from 'react-apollo';
import { GET_USERS } from 'graphql/campaigns';

const RECIPIENT_OPTIONS = [
  { label: 'Send to all students and parents', value: 'all' },
  { label: 'Send to selected users', value: 'users' },
  { label: 'Send to filtered contacts', value: 'filters' },
];

const RULE_OPTIONS = [
  { label: 'User Type', value: 'role' },
  { label: 'Product Type', value: 'product_type' },
  { label: 'Graduation Year', value: 'graduation_year' },
];

const USER_OPTIONS = [
  { label: 'Student', value: 'student' },
  { label: 'Guardian', value: 'parent' },
];

const currentyear = new Date().getFullYear();

const GRADUATION_YEARS = times(10).map((i) => ({
  label: currentyear + i,
  value: currentyear + i,
}));

const VALUE_OPTIONS = {
  role: USER_OPTIONS,
  product_type: ProductTypes,
  graduation_year: GRADUATION_YEARS,
};

const required = (value) => (!value ? 'This field is required' : null);

const Rule = ({ field, recipient }) => {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item md={6}>
          <Field
            noMargin
            transformValue
            isMulti={false}
            name={`${field.name}.criterion`}
            component={Select}
            placeholder="Condition"
            validate={required}
            options={RULE_OPTIONS}
          />
        </Grid>
        <Grid item md={6}>
          <Field
            noMargin
            transformValue
            name={`${field.name}.value`}
            component={Select}
            placeholder="Value"
            validate={required}
            options={
              recipient.criterion ? VALUE_OPTIONS[recipient.criterion] : []
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

const Rules = ({ recipients }) => {
  const { data: usersResp } = useQuery(GET_USERS);

  return (
    <Box mb={3}>
      <Field
        row
        name="recipients.type"
        component={RadioGroup}
        options={RECIPIENT_OPTIONS}
        label="Recipients"
        validate={required}
      />
      {recipients.type === 'users' && (
        <Field name="recipients.users">
          {(props) => (
            <Select
              {...props}
              transformValue
              options={usersResp?.users.map((u) => ({

                value: u.user_id,
                label: `${u.user_preferred_name || u.user_first_name} ${u.user_last_name}`,
              }))}
              placeholder="Search..."
              label="Select Recipients"
            />
          )}
        </Field>
      )}
      {recipients.type === 'all' && (
        <Field name="recipients.include_past_students"
          component={Switch}
          label="Include past clients"
        />
      )}
      {recipients.type === 'filters' && (
        <FieldArray
          name="recipients.filters"
          render={(arrayHelpers) => (
            <>
              {recipients.filters?.length > 0 ? (
                recipients.filters.map((recipient, index) => (
                  <div key={index}>
                    <Paper component={Box} p={1}>
                      <Grid container spacing={2}>
                        <Grid item md={9}>
                          <Field
                            name={`recipients.filters.${index}`}
                            component={Rule}
                            recipient={recipient}
                          />
                        </Grid>
                        <Grid item md={3}>
                          <IconButton
                            type="button"
                            onClick={() => arrayHelpers.remove(index)}
                          >
                            <RemoveIcon />
                          </IconButton>
                          {index === recipients.filters.length - 1 && (
                            <IconButton
                              type="button"
                              onClick={() => arrayHelpers.push({})}
                            >
                              <AddIcon />
                            </IconButton>
                          )}
                        </Grid>
                      </Grid>
                    </Paper>
                    {recipients.filters.length > 1 &&
                      index !== recipients.filters.length - 1 && (
                        <Box marginY={2}>
                          <Typography align="center" variant="body2">
                            AND
                          </Typography>
                        </Box>
                      )}
                  </div>
                ))
              ) : (
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() => arrayHelpers.push({})}
                >
                  Add Filter
                </Button>
              )}
            </>
          )}
        />
      )}
    </Box>
  );
};

export default Rules;
